import { Code } from 'lucide-react';
import type { CodeBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const codeConfig: BlockTypeConfig<CodeBlock> = {
  type: 'code',
  label: 'Embed',
  description: 'Raw HTML embed for third-party widgets and scripts',
  icon: Code,
  category: 'data',
  createDefault: () => ({
    html: '',
    background: 'transparent',
    padded: false,
    rounded: true,
    border: false,
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.background',
      label: 'Background',
      options: [
        { value: 'transparent', label: 'None' },
        { value: 'muted', label: 'Muted' },
        { value: 'card', label: 'Card' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  sheet: [
    {
      kind: 'group',
      label: 'Embed code',
      fields: [
        {
          kind: 'textarea',
          path: 'data.html',
          label: 'HTML / embed script',
          placeholder: '<iframe src="…"></iframe>  or  <script src="…"></script>',
          rows: 10,
          mono: true,
        },
        { kind: 'text', path: 'data.caption', label: 'Caption' },
      ],
    },
    {
      kind: 'group',
      label: 'Frame',
      fields: [
        { kind: 'toggle', path: 'data.padded', label: 'Inner padding' },
        { kind: 'toggle', path: 'data.rounded', label: 'Rounded corners' },
        { kind: 'toggle', path: 'data.border', label: 'Border' },
        { kind: 'number', path: 'data.maxHeight', label: 'Max height (px)', min: 100, max: 5000 },
      ],
    },
  ],
};
